import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  min-width: 320px;
`;
const Template = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Template;
